import { render, staticRenderFns } from "./RealTimeClock.vue?vue&type=template&id=067c7293&scoped=true&"
import script from "./RealTimeClock.vue?vue&type=script&lang=js&"
export * from "./RealTimeClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c7293",
  null
  
)

export default component.exports